import React, { Component } from "react";
import "./Mask.css";

export default class Mask extends Component {
  render() {
    return <div className="mask"></div>;
  }
}
